(() => {
  const STRIPE = [
    null, ['#bc1024'], ['#ed6b16'], ['#e9b514'], ['#168047'],
    ['#33a8e7'], ['#174990'], ['#72339b'], ['#f4f4ef'],
    ['#48a5de', '#153c89', '#d12736'],
    ['#1a1b1c', '#c8262c', '#ddb83d'],
    ['#14934f', '#f5f5f1', '#d52b34']
  ];
  const STITCH = [
    ['#202126'], ['#f5f5f1'], ['#c92731'], ['#e97920'],
    ['#e6b31f'], ['#17854d'], ['#49a6dd'], ['#1c4a93'], ['#753e9c'],
    ['#48a5de', '#153c89', '#d12736'],
    ['#1a1b1c', '#c8262c', '#ddb83d'],
    ['#14934f', '#f5f5f1', '#d52b34']
  ];
  const names = {
    carbon: 'Blue-flake forged carbon - supplied swatch',
    paddle: 'Paddle shifters - fixed black carbon',
    grip: 'Grey Alcantara - supplied swatch',
    trimShell: 'Configurable middle trim shell',
    buttonTrim: 'Middle button surrounds - configurable finish',
    noHole: 'Configurable no-hole center insert',
    cover: 'Configurable airbag cover',
    coverStitch: ['Configurable airbag stitch outer', 'Configurable airbag stitch middle', 'Configurable airbag stitch inner'],
    stripe: ['BMW stripe - light blue', 'BMW stripe - dark blue', 'BMW stripe - red'],
    stitch: ['BMW tri-color thread - light blue', 'BMW tri-color thread - dark blue', 'BMW tri-color thread - red']
  };
  const id = (state, key, fallback = '0') => String(state[key] ?? fallback);
  const indexed = (prefix, value) => `${prefix}-${id(value.state, value.key, value.fallback)}.jpg`;

  function start(root) {
    const viewer = root.querySelector('[data-scdwb-live-model]');
    const live = root.querySelector('[data-scdwb-live-panel]');
    const photos = root.querySelector('[data-scdwb-photo-panel]');
    const status = root.querySelector('[data-scdwb-live-status]');
    const gripFields = JSON.parse(root.querySelector('[data-scdwb-config]').textContent).catalog.fields;
    const fullscreen = root.querySelector('[data-scdwb-fullscreen]');
    if (!viewer || !live || !photos || !status) return;
    if (fullscreen && document.fullscreenEnabled && live.requestFullscreen) {
      fullscreen.hidden = false;
      fullscreen.addEventListener('click', async () => {
        try {
          if (document.fullscreenElement === live) await document.exitFullscreen();
          else await live.requestFullscreen();
        } catch (error) {
          console.warn('Fullscreen wheel preview unavailable', error);
        }
      });
      document.addEventListener('fullscreenchange', () => {
        const active = document.fullscreenElement === live;
        fullscreen.setAttribute('aria-pressed', String(active));
        fullscreen.setAttribute('aria-label', active ? 'Exit fullscreen 3D view' : 'Enter fullscreen 3D view');
        fullscreen.lastChild.textContent = active ? ' Exit full screen' : ' Full screen';
      });
    }
    let map = {};
    try { map = JSON.parse(root.dataset.assetMap || '{}'); } catch { /* keep empty map */ }
    // Use the original weave for black twill. Its material map, unlike the
    // photographed thumbnail, does not repeat broad square shadows.
    map['material-twill-0.jpg'] = 'https://cdn.shopify.com/s/files/1/0780/0356/8812/files/shop-carbon-parts-wheel-black-twill-original-weave-20260924.png?v=1790245261';
    const safeURL = key => {
      const value = map[key];
      if (!value) return null;
      try {
        const url = new URL(value, location.href);
        return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' ? url.href : null;
      } catch { return null; }
    };
    const textureCache = new Map();
    const texture = key => {
      const url = safeURL(key);
      if (!url) return Promise.reject(new Error(`Missing swatch ${key}`));
      if (!textureCache.has(url)) textureCache.set(url, viewer.createTexture(url, /\.png(?:\?|$)/i.test(url) ? 'image/png' : 'image/jpeg'));
      return textureCache.get(url);
    };
    const materialTexture = key => texture(safeURL(`material-${key}`) ? `material-${key}` : key);
    const material = name => viewer.model?.getMaterialByName(name);
    const baseModelURL=viewer.getAttribute('src');
    const ledModelURL=root.dataset.ledModelUrl;
    const sourceNormals=new WeakMap();
    async function updateLedWheel(state,request){
      const family=id(state,'carbon');
      const carbonKey=family==='1'?indexed('forged',{state,key:'forged'}):family==='2'?indexed('honey',{state,key:'honey'}):indexed('twill',{state,key:'twill'});
      const match=id(state,'trimCarbonFinish')==='1';
      const trimKey=match?carbonKey:'twill-0.jpg';
      const gripFamily=id(state,'leather','1'),gripField=gripFamily==='2'?'alcColor':gripFamily==='0'?'smoothColor':'perfColor';
      const gripOption=gripFields.find(f=>f.id===gripField)?.options.find(o=>o.id===id(state,gripField));
      const gripKey=gripOption?.materialBase||indexed(gripFamily==='2'?'alc':gripFamily==='0'?'smooth':'perf',{state,key:gripField});
      const stitchIndex=Number(id(state,'stitch')),stitchMap=['bmw','german','italian'][stitchIndex-9]||'neutral';
      const [carbon,trim,paddle,grip,alc,smooth,stitch]=await Promise.all([materialTexture(carbonKey),materialTexture(trimKey),materialTexture('twill-0.jpg'),gripFamily==='2'?texture(gripKey):materialTexture(gripKey),texture('alc-0.jpg'),materialTexture('smooth-0.jpg'),texture(`stitch-mask-${stitchMap}.png`)]);
      if(request!==updateId)return;
      for(const map of [carbon,trim,paddle,grip,alc,smooth,stitch]){
        map.sampler.setWrapS(10497);map.sampler.setWrapT(10497);
      }
      const finish=(name,map,tint,roughness)=>{
        const part=material('SCP LED - '+name);if(!part)return;
        if(!sourceNormals.has(part))sourceNormals.set(part,part.normalTexture?.texture||null);
        part.pbrMetallicRoughness.baseColorTexture.setTexture(map);
        part.pbrMetallicRoughness.setBaseColorFactor(tint);
        part.pbrMetallicRoughness.setRoughnessFactor(roughness);
        part.pbrMetallicRoughness.setMetallicFactor(0);
        part.normalTexture?.setTexture(null);
        return part;
      };
      finish('carbon rim',carbon,'#ffffff',.22);
      finish('paddle shifters',paddle,'#ffffff',.22);
      const side=finish('side grips',grip,gripOption?.tint||'#ffffff',gripFamily==='2'?.88:gripFamily==='0'?.68:.58);
      if(side&&gripFamily==='1')side.normalTexture?.setTexture(sourceNormals.get(side));
      const customTrim=id(state,'trim')==='1',trimType=id(state,'trimMaterial');
      const shellTexture=customTrim?(trimType==='0'?alc:trimType==='2'?smooth:trim):null;
      finish('outer trim shell',shellTexture,customTrim?'#ffffff':'#17191b',customTrim&&trimType==='1'?.22:trimType==='0'?.9:.65);
      finish('middle trim',customTrim?trim:paddle,'#ffffff',.25);
      const fill=finish('no-hole center insert',customTrim?trim:paddle,'#ffffff',.25);
      const fillVisible=customTrim&&id(state,'trimStyle')==='0';
      fill?.setAlphaMode(fillVisible?'OPAQUE':'BLEND');
      fill?.pbrMetallicRoughness.setBaseColorFactor(fillVisible?'#ffffff':[1,1,1,0]);
      const openTrim=finish('with-hole lower trim',customTrim?trim:paddle,'#ffffff',.25);
      openTrim?.setAlphaMode('OPAQUE');
      openTrim?.pbrMetallicRoughness.setBaseColorFactor('#ffffff');
      const customCover=id(state,'airbag')==='1',alcCover=customCover&&id(state,'airbagMaterial')==='1';
      finish('airbag cover',alcCover?alc:null,alcCover?'#ffffff':'#17191b',alcCover?.96:.65);
      const thread=finish('grip stitching',stitch,stitchIndex>=9?'#ffffff':(STITCH[stitchIndex]||STITCH[0])[0],.7);
      thread?.setAlphaMode('BLEND');
      const coverThread=!customCover?['#1c1c1c']:Number(id(state,'airbagStitch'))===3?['#49a6dd','#c92731']:[['#c92731'],['#f4f4f1'],['#1c1c1c'],null,['#1c1c1c']][Number(id(state,'airbagStitch'))]||['#1c1c1c'];
      for(const [i,name] of ['airbag outer stitching','airbag inner stitching'].entries()){
        const part=material('SCP LED - '+name);
        part?.setAlphaMode('BLEND');
        part?.pbrMetallicRoughness.setBaseColorFactor(coverThread[i%coverThread.length]);
      }
      status.textContent='3D preview updated to your swatches.';
      root.dataset.previewReadyState=JSON.stringify(state);
      root.dispatchEvent(new CustomEvent('scdwb:preview-ready',{detail:{state:{...state}}}));
    }
    const setColor = (name, color, alpha = 1, keepThreadMask = false) => {
      const target = material(name);
      if (!target) throw new Error(`3D part not found: ${name}`);
      target.setAlphaMode(keepThreadMask || alpha < 1 ? 'BLEND' : 'OPAQUE');
      if (alpha === 1) target.pbrMetallicRoughness.setBaseColorFactor(color);
      else target.pbrMetallicRoughness.setBaseColorFactor([1, 1, 1, alpha]);
    };
    const setPalette = (parts, palette, keepThreadMask = false) => {
      parts.forEach((name, index) => setColor(name, palette?.[index % palette.length] || '#f4f4f1', palette ? 1 : 0, keepThreadMask));
    };
    let updateId = 0;
    let gripNormal;
    let coverNormal;
    async function update(state) {
      const requestedModel=id(state,'led')==='1'&&ledModelURL?ledModelURL:baseModelURL;
      if(viewer.getAttribute('src')!==requestedModel){
        ++updateId;delete root.dataset.previewReadyState;
        status.textContent='Loading selected steering wheel…';
        viewer.setAttribute('src',requestedModel);return;
      }
      if (!viewer.model) return;
      const request = ++updateId;
      delete root.dataset.previewReadyState;
      status.textContent = 'Updating 3D preview…';
      try {
        if(material('SCP LED - carbon rim')){await updateLedWheel(state,request);return;}
        const carbonFamily = id(state, 'carbon');
        const carbonKey = carbonFamily === '1' ? indexed('forged', {state, key: 'forged'})
          : carbonFamily === '2' ? indexed('honey', {state, key: 'honey'})
          : indexed('twill', {state, key: 'twill'});
        const matchTrim = id(state, 'trimCarbonFinish') === '1';
        const trimCarbonKey = matchTrim ? carbonKey : 'twill-0.jpg';
        const gripFamily = id(state, 'leather', '1');
        const gripField = gripFamily === '2' ? 'alcColor' : gripFamily === '0' ? 'smoothColor' : 'perfColor';
        const gripOption = gripFields.find(f => f.id === gripField)?.options.find(o => o.id === id(state, gripField));
        const gripKey = gripOption?.materialBase || (gripFamily === '2' ? indexed('alc', {state, key: 'alcColor'})
          : gripFamily === '0' ? indexed('smooth', {state, key: 'smoothColor'})
          : indexed('perf', {state, key: 'perfColor'}));
        const stitchIndex = Number(id(state, 'stitch'));
        const stitchMap = ['bmw', 'german', 'italian'][stitchIndex - 9] || 'neutral';
        const [carbonTexture, trimCarbonTexture, paddleTexture, gripTexture, trimAlcantaraTexture, trimLeatherTexture, stitchTexture] = await Promise.all([
          materialTexture(carbonKey), materialTexture(trimCarbonKey),
          materialTexture('twill-0.jpg'),
          gripFamily === '2' ? texture(gripKey) : materialTexture(gripKey),
          texture('alc-0.jpg'), materialTexture('smooth-0.jpg'), texture(`stitch-mask-${stitchMap}.png`)
        ]);
        if (request !== updateId) return;
        const carbon = material(names.carbon);
        const paddle = material(names.paddle);
        const grip = material(names.grip);
        const trimShell = material(names.trimShell);
        const buttonTrim = material(names.buttonTrim);
        const noHole = material(names.noHole);
        const cover = material(names.cover);
        if (!carbon || !paddle || !grip || !trimShell || !buttonTrim || !noHole || !cover || names.coverStitch.some(name => !material(name))) throw new Error('Configurable 3D materials are missing');
        gripNormal ??= grip.normalTexture?.texture ?? null;
        coverNormal ??= cover.normalTexture?.texture ?? null;
        carbon.pbrMetallicRoughness.baseColorTexture.setTexture(carbonTexture);
        // Reflective finishes use the user's original color-fiber swatches.
        // A neutral base factor preserves their actual red/blue/green/gold hues.
        const carbonTint = '#ffffff';
        const reflectiveLight = carbonFamily === '0' ? ({
          '11': [0.65, 0, 0], '12': [0, 0.12, 0.65],
          '13': [0.02, 0.65, 0], '14': [0.65, 0.32, 0]
        })[id(state, 'twill')] : null;
        carbon.pbrMetallicRoughness.setBaseColorFactor(carbonTint);
        carbon.pbrMetallicRoughness.setMetallicFactor(0.04);
        carbon.pbrMetallicRoughness.setRoughnessFactor(0.22);
        carbon.normalTexture?.setTexture(null);
        carbon.emissiveTexture?.setTexture(reflectiveLight ? carbonTexture : null);
        carbon.setEmissiveFactor?.(reflectiveLight || [0, 0, 0]);
        paddle.pbrMetallicRoughness.baseColorTexture.setTexture(paddleTexture);
        paddle.pbrMetallicRoughness.setBaseColorFactor('#ffffff');
        paddle.pbrMetallicRoughness.setMetallicFactor(0.04);
        paddle.pbrMetallicRoughness.setRoughnessFactor(0.22);
        paddle.normalTexture?.setTexture(null);
        grip.pbrMetallicRoughness.baseColorTexture.setTexture(gripTexture);
        grip.pbrMetallicRoughness.setBaseColorFactor(gripOption?.tint || '#ffffff');
        grip.pbrMetallicRoughness.setMetallicFactor(0);
        grip.pbrMetallicRoughness.setRoughnessFactor(gripFamily === '2' ? 0.88 : gripFamily === '0' ? 0.68 : 0.58);
        grip.normalTexture?.setTexture(gripFamily === '1' ? gripNormal : null);
        setPalette(names.stripe, STRIPE[Number(id(state, 'stripe'))] ?? null);
        names.stitch.forEach(name => {
          const thread = material(name);
          thread.setAlphaMode('BLEND');
          thread.pbrMetallicRoughness.baseColorTexture.setTexture(stitchTexture);
          thread.pbrMetallicRoughness.setBaseColorFactor(stitchIndex >= 9 ? '#ffffff' : (STITCH[stitchIndex] || STITCH[0])[0]);
        });

        // Carbon on the button surrounds and center insert keeps the selected
        // middle-trim finish. The Y-shaped outer shell alone takes fabric when
        // Alcantara or leather is chosen under the trim-material upgrade.
        const customTrim = id(state, 'trim') === '1';
        const trimMaterial = id(state, 'trimMaterial');
        const fullCarbonTrim = !customTrim || trimMaterial === '1';
        const trimTexture = !customTrim ? paddleTexture
          : trimMaterial === '0' ? trimAlcantaraTexture
          : trimMaterial === '2' ? trimLeatherTexture : trimCarbonTexture;
        for (const [part, partTexture, carbonSurface] of [
          [trimShell, trimTexture, fullCarbonTrim],
          [buttonTrim, customTrim ? trimCarbonTexture : paddleTexture, true]
        ]) {
          part.pbrMetallicRoughness.baseColorTexture.setTexture(partTexture);
          part.pbrMetallicRoughness.setBaseColorFactor('#ffffff');
          part.pbrMetallicRoughness.setRoughnessFactor(carbonSurface ? 0.22 : trimMaterial === '0' ? 0.9 : 0.65);
          part.normalTexture?.setTexture(null);
          part.emissiveTexture?.setTexture(customTrim && carbonSurface && matchTrim && reflectiveLight ? trimCarbonTexture : null);
          part.setEmissiveFactor?.(customTrim && carbonSurface && matchTrim && reflectiveLight ? reflectiveLight : [0, 0, 0]);
        }
        const fillVisible = customTrim && id(state, 'trimStyle') === '0';
        noHole.setAlphaMode(fillVisible ? 'OPAQUE' : 'BLEND');
        noHole.pbrMetallicRoughness.baseColorTexture.setTexture(trimCarbonTexture);
        noHole.pbrMetallicRoughness.setBaseColorFactor(fillVisible ? '#ffffff' : [1, 1, 1, 0]);
        noHole.normalTexture?.setTexture(null);

        const customCover = id(state, 'airbag') === '1';
        const alcantaraCover = customCover && id(state, 'airbagMaterial') === '1';
        cover.pbrMetallicRoughness.baseColorTexture.setTexture(alcantaraCover ? trimAlcantaraTexture : null);
        cover.pbrMetallicRoughness.setBaseColorFactor(alcantaraCover ? '#ffffff' : '#17191b');
        cover.pbrMetallicRoughness.setRoughnessFactor(alcantaraCover ? 0.96 : 0.65);
        cover.normalTexture?.setTexture(alcantaraCover ? null : coverNormal);
        const airbagStitchId = Number(id(state, 'airbagStitch'));
        const coverThread = !customCover ? ['#1c1c1c'] : airbagStitchId === 3
          ? ['#49a6dd', '#194b93', '#c92731']
          : [['#c92731'], ['#f4f4f1'], ['#1c1c1c'], null, ['#1c1c1c']][airbagStitchId] || ['#1c1c1c'];
        names.coverStitch.forEach((name, index) => material(name).pbrMetallicRoughness.setBaseColorFactor(coverThread[index % coverThread.length]));
        status.textContent = '3D preview updated to your swatches.';
        root.dataset.previewReadyState = JSON.stringify(state);
        root.dispatchEvent(new CustomEvent('scdwb:preview-ready', {detail:{state:{...state}}}));
      } catch (error) {
        if (request !== updateId) return;
        console.error('Wheel preview update failed', error);
        delete root.dataset.previewReadyState;
        status.textContent = '3D swatch update unavailable; product photos remain available.';
      }
    }
    function show(mode) {
      const show3D = mode === '3d';
      live.hidden = !show3D;
      photos.hidden = show3D;
      root.querySelectorAll('[data-scdwb-view]').forEach(button => {
        const active = button.dataset.scdwbView === mode;
        button.setAttribute('aria-pressed', String(active));
        button.classList.toggle('scdwb-active', active);
      });
    }
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-scdwb-view]');
      if (button && root.contains(button)) show(button.dataset.scdwbView);
    });
    root.addEventListener('scdwb:selection', event => update(event.detail.state));
    viewer.addEventListener('load', () => {
      gripNormal=undefined;coverNormal=undefined;
      let state = {};
      try { state = JSON.parse(root.dataset.wheelState || '{}'); } catch { /* defaults */ }
      update(state);
    });
    viewer.addEventListener('error', () => { status.textContent = '3D preview could not load. Use Product photos instead.'; });
    show('3d');
    if (viewer.model) {
      let state = {};
      try { state = JSON.parse(root.dataset.wheelState || '{}'); } catch { /* defaults */ }
      update(state);
    }
  }

  const initialize = () => document.querySelectorAll('scd-wheel-builder').forEach(start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
})();

